import { Colors } from '@factorialco/deprecated-design-system'
import { upperCase } from 'lodash'
import moment from 'moment'

import { formatSecondsToHM } from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'

import type UnassignedShift from '../store/internal/models/UnassignedShift'

export interface Props {
  unassignedShifts: UnassignedShift[]
}

interface UnassignedShiftSummary {
  color: Colors
  title: string
  counter: number
}

const useCalculateSummaryUnassignedShifts = ({ unassignedShifts }: Props) => {
  let totalCounters = 0
  let totalSeconds = 0
  unassignedShifts.map((unassignedShift) => {
    totalCounters += unassignedShift.counter
    const datesDuration = moment.duration(unassignedShift.endAt.diff(unassignedShift.startAt))
    totalSeconds +=
      unassignedShift.counter *
      (Math.floor(datesDuration.asHours()) * 3600 + datesDuration.minutes() * 60)
  })

  const totalTime = upperCase(formatSecondsToHM(totalSeconds))

  return {
    totalCounters,
    totalTime,
  }
}

const useCalculateSummaryFromShifts = ({ unassignedShifts }: Props) => {
  const summaryFromShifts = new Map()

  unassignedShifts.map((unassignedShift) => {
    const map_key =
      unassignedShift.defaultShiftId == null ? 'custom' : unassignedShift.defaultShiftId

    if (summaryFromShifts.has(map_key)) {
      const unassignedShiftCurrent = summaryFromShifts.get(map_key)
      const counters = unassignedShiftCurrent.counter + unassignedShift.counter
      unassignedShiftCurrent.counter = counters
      summaryFromShifts.set(map_key, unassignedShiftCurrent)
    } else {
      const unassignedShiftInfo = {
        color: map_key == 'custom' || !unassignedShift.color ? 'grey400' : unassignedShift.color,
        title:
          map_key == 'custom'
            ? i18n.t('shift_management.coverage_section.other_shifts_summary')
            : unassignedShift.defaultShiftTitle,
        counter: unassignedShift.counter,
      }
      summaryFromShifts.set(map_key, unassignedShiftInfo)
    }
  })

  return {
    summaryFromShifts,
  }
}

export { useCalculateSummaryUnassignedShifts }
